import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AppRoutes } from './app/routes';
import { Splash } from './components/ui/Splash';
import { useSession } from './stores/session';

export default function App() {
  const ready = useSession((s) => s.ready);
  const bootstrap = useSession((s) => s.bootstrap);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  /*
   * Nothing renders until the session question has an answer.
   *
   * The access token lives in memory only, so every page load starts signed out
   * and exchanges the refresh cookie for a new one. That round trip is fast but
   * not instant, and rendering routes during it would show a returning visitor
   * the signed-out home page, then flip - or worse, bounce them off a protected
   * route they deep-linked to, losing where they were going.
   *
   * A blank frame for one request is the better trade - and `Splash` keeps it
   * literally blank for the first 400ms, so the usual fast answer shows nobody
   * anything at all. The boot screen is for the cold load and the slow network.
   */
  if (!ready) {
    return <Splash />;
  }

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
